const localUrl = 'http://localhost:3000/dev';
const apiUrl = 'https://xgs6ol2n69.execute-api.us-east-1.amazonaws.com/prod';

export default {
  url: process.env.NODE_ENV === 'production' ? apiUrl : localUrl,
};



// WEBPACK FOOTER //
// ./src/configs/configs.api.js